import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (key: string) => {
    setOpen(false);
    document.getElementById(key)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        {/* brand */}
        <a href="#" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2.5">
          <span className="relative flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-lg bg-primary-500 font-label text-sm md:text-base font-black text-background-50">
            17
            <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-accent-500 ring-2 ring-background-50" />
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading text-lg md:text-xl font-bold tracking-wide ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
              17黑料
            </span>
            <span className={`text-[10px] mt-1 tracking-[0.2em] ${scrolled ? "text-foreground-500" : "text-background-100/90"}`}>
              围观 · 热议 · 观点
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => (
            <button
              key={l.key}
              onClick={() => jump(l.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                  : "text-background-100 hover:bg-background-50/20 hover:text-background-50"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        {/* right actions */}
        <div className="hidden md:flex items-center gap-3">
          <div className={`flex items-center gap-2 rounded-full px-3.5 py-2 ${scrolled ? "bg-background-100 border border-background-200" : "bg-background-50/15"}`}>
            <i className={`ri-search-line text-sm ${scrolled ? "text-foreground-500" : "text-background-100"}`}></i>
            <input
              placeholder="搜个话题"
              className="w-32 bg-transparent text-sm outline-none placeholder:text-foreground-400 placeholder:text-background-100/80"
              style={{ color: scrolled ? "oklch(var(--foreground-900))" : "oklch(var(--background-50))" }}
            />
          </div>
          <button
            onClick={() => jump("tea")}
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            去茶馆聊聊
          </button>
        </div>

        {/* mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full md:hidden"
          style={{ color: scrolled ? "oklch(var(--foreground-950))" : "oklch(var(--background-50))" }}
          aria-label="菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
        </button>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((l) => (
              <button
                key={l.key}
                onClick={() => jump(l.key)}
                className="rounded-lg bg-background-100 px-4 py-3 text-left text-sm text-foreground-800 hover:bg-background-200"
              >
                {l.label}
              </button>
            ))}
          </div>
          <button
            onClick={() => jump("tea")}
            className="mt-3 w-full whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
          >
            去茶馆聊聊
          </button>
        </div>
      )}
    </header>
  );
}